module.exports = __webpack_public_path__ + "static/img/caih-login-camera.2b34edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caih-login-camera.png
// module id = Fj50
// module chunks = 1